import Image from 'next/image';
import { CarouselImageDiv } from '../../IVF/IVFCarousel/styled';
import { TestiImgContainer } from '../Testimonials/styled';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils';

function index(props) {
  const { element, index, sectionName, length, banner, position } = props;

  const getDesktopImage = (product) => {
    return product?.desktopImage || product?.mobileWebImage || product?.image;
  };
  const getMobileImage = (product) => {
    return product?.mobileWebImage || product?.desktopImage || product?.image;
  };
  const onClickEvent = () => {
    const sectionDetails = {
      heading: banner?.itemName,
      itemId: banner?._id,
      position: position,
    };
    clickCardEvent(element, sectionDetails, false);
  };

  return (
    <TestiImgContainer
      id={
        index == 0
          ? `${sectionName}first`
          : index == length - 1
            ? `${sectionName}last`
            : `testimonial${index}`
      }
      key={index}
    >
      <CarouselImageDiv onClick={onClickEvent} testimonial>
        <Image
          className="carousel-mobile image"
          src={getMobileImage(element)}
          alt=""
          quality={90}
          loading="lazy"
          fill
          sizes="100vw"
        />
        <Image
          className="carousel-desktop image"
          src={getDesktopImage(element)}
          alt=""
          quality={90}
          loading="lazy"
          fill
          sizes="100vw"
        />
      </CarouselImageDiv>
      {/* <CarouselImage
                testimonial
                src={getMobileImage(element)}
                srcSet={`${getMobileImage(
                    element,
                )}?tr=w-400,q-80 400w, ${getDesktopImage(
                    element,
                )}?tr=w-500,q-80 500w,${getDesktopImage(
                    element,
                )}?tr=w-720,q-80 720w`}
                sizes="(max-width: 720px) 400px, (min-width: 1080px) 500px, 400px"
                loading="lazy"
            /> */}
    </TestiImgContainer>
  );
}

export default index;
